import React, { useState, useEffect } from "react";
import { toolsAPI } from "../../utils/funcionesAPI";
import { manejadorDeRespuesta } from "../../utils/Tools";
import { RUTA_IMAGEN } from "../../utils/rutasFijas";

const Carteleras = (props) => {
  const { history } = props;
  const [carteleras, setCarteleras] = useState([]);
  const token = sessionStorage.getItem("token");
  const user = sessionStorage.getItem("usuario");

  if (!token && !user) {
    history.push("/login");
  }

  const traerCarteleras = () => {
    const data = JSON.stringify({ accion: "traerCarteleras", token: token });
    toolsAPI(data).then((respuesta) => {
      if (manejadorDeRespuesta(props, respuesta)) {
        setCarteleras(respuesta.data);
      }
    });
  };

  useEffect(() => {
    traerCarteleras();
  }, []);

  return (
    <section className="carteleras">
      <div className="container">
        <div className="row">
          <article className="txt col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
            <h1>Vidrieras</h1>
            <hr />
            <p>
              Desde aqu&iacute; pod&eacute;s descargar nuestros afiches de cada
              destino y publicarlos en tu web, redes sociales o imprimirlos para
              decorar tu vidriera o local.
            </p>
            {carteleras.map((cartelera, index) => {
              return (
                <div className="img-container" key={index}>
                  <p className="txtCartelera">{cartelera.descripcion}</p>
                  <img
                    style={{ marginBottom: "10px" }}
                    src={RUTA_IMAGEN + "carteleras/chiquitas/" + cartelera.url}
                    alt={cartelera.descripcion}
                    widht="200"
                    height="283"
                  />
                  <a
                    className="btnDescargar"
                    href={RUTA_IMAGEN + "carteleras/grandes/" + cartelera.url}
                    target="_blank"
                    download={cartelera.url}
                  >
                    Descargar
                  </a>
                </div>
              );
            })}
          </article>
        </div>
      </div>
    </section>
  );
};

export default Carteleras;




// WEBPACK FOOTER //
// ./src/components/Global/Carteleras.js